var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete_icon",
    className: "delete_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.3,
    height: 36.691,
    viewBox: "0 0 16.3 18.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "trash-can-solid",
    d: "M1.664,6.657H15.636V18.3a2.331,2.331,0,0,1-2.329,2.329H3.993A2.331,2.331,0,0,1,1.664,18.3ZM5.157,8.986a.584.584,0,0,0-.582.582v8.15a.582.582,0,0,0,1.164,0V9.568A.584.584,0,0,0,5.157,8.986Zm3.493,0a.584.584,0,0,0-.582.582v8.15a.582.582,0,0,0,1.164,0V9.568A.584.584,0,0,0,8.65,8.986Zm3.493,0a.584.584,0,0,0-.582.582v8.15a.582.582,0,0,0,1.164,0V9.568A.584.584,0,0,0,12.143,8.986Z",
    transform: "translate(-0.5 -1.938)",
    fill: "#f634f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "trash-can-solid-2",
    id: "trash-can-solid-2",
    "data-name": "trash-can-solid",
    d: "M4.919.644A1.16,1.16,0,0,1,5.96,0H10.34a1.16,1.16,0,0,1,1.041.644l.262.52h3.493a1.164,1.164,0,1,1,0,2.329H1.164a1.164,1.164,0,1,1,0-2.329H4.657Z",
    fill: "#f634f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a3d7c5c6c240796b5a381a021f2f820d.svg";
export { ForwardRef as ReactComponent };